<template>
  <el-header
    height="60px"
    class="layout-header">
    <div>
      <el-menu
        :default-active="active"
        active-text-color="#000"
        mode="horizontal">
        <el-menu-item
          v-for="item in module"
          :key="item.activePath"
          :index="item.activePath + ''"
          @click="openUrl(item.funcAddress)">{{ item.menuName }}</el-menu-item>
        <!-- <el-menu-item index="2">新零售运营</el-menu-item>
        <el-menu-item index="3">审单中心</el-menu-item>
        <el-menu-item index="4">数据中心</el-menu-item>
        <el-menu-item index="5">基础配置</el-menu-item> -->
      </el-menu>
    </div>
    <div class="user">
      <tag-search-form
        v-if="userPermission.ENT || userPermission.OPERATE"
        :vendorId="userInfo.orgId"
      />
      <!-- <print-demo /> -->
      <user-message-icon />
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ userInfo.account
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item
            v-if="userPermission.ENT"
            @click.native="entInfo">企业信息</el-dropdown-item> -->
          <el-dropdown-item
            v-if="userPermission.ENT"
            @click.native="updatePwd"
          >修改密码</el-dropdown-item
          >
          <el-dropdown-item @click.native="logout">退出登陆</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <password-modal
      ref="modal"
      :account="userInfo.account"
      :callback="logout"
    />
  </el-header>
</template>
<script>
import PasswordModal from './password-modal.vue'
import TagSearchForm from './tag-search-form.vue'
import { mapState } from 'vuex'
import UserMessageIcon from '../user-message-icon.vue'
// import PrintDemo from '../print-demo.vue'
export default {
  name: 'LayoutHeader',
  components: { PasswordModal, TagSearchForm, UserMessageIcon },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission,
      userDetail: state => state.account.userDetail,
      module: state => state.account.module
    }),
    active() {
      return this.$route.meta.activeTopPath
    }
  },
  mounted() {},
  methods: {
    openUrl(url) {
      this.$store.commit('common/resetQuery', {})
      this.$router.push(url)
    },
    logout() {
      this.$store.dispatch('account/logout', {
        payload: {},
        success: () => {
          this.$router.push({ path: '/login' })
        }
      })
    },
    entInfo() {
      this.$router.push('/ent?vendorId=' + this.userInfo.orgId)
    },
    updatePwd() {
      this.$refs.modal.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus" scoped>
.layout-header {
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0 6px rgba(0, 21, 41, 0.2);
  z-index: 9;

  .el-menu-item {
    font-weight: 600;
    font-size: 16px !important;
  }

  .name {
    font-size: 15px;
    margin: 0 10px;
  }

  .user {
    display: flex;
    align-items: center;

    .el-dropdown-link {
      cursor: pointer;
      color: #333;
    }
  }
}
</style>
